import { Component, Input, OnInit } from '@angular/core';
import { Loader, NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-tableloader',
  templateUrl: './tableloader.component.html',
  styleUrls: ['./tableloader.component.scss']
})
export class TableloaderComponent implements OnInit {
  ngxuiloaderconfiguration: any =
    {
      "bgsColor": "#3a2d78",
      "bgsOpacity": 10,
      "bgsPosition": "center-center",
      "bgsSize": 60,
      "bgsType": "rectangle-bounce",
      "blur": 10,
      "delay": 0,
      "fastFadeOut": true,
      "fgsColor": "#3a2d78",
      "fgsPosition": "center-center",
      "fgsSize": 60,
      "fgsType": "rectangle-bounce",
      "gap": 24,
      "logoPosition": "center-center",
      "logoSize": 120,
      "logoUrl": "",
      "masterLoaderId": "master",
      "overlayBorderRadius": "0",
      "overlayColor": "#0000000f",
      "pbColor": "red",
      "pbDirection": "ltr",
      "pbThickness": 3,
      "hasProgressBar": true,
      "text": "",
      "textColor": "#FFFFFF",
      "textPosition": "center-center",
      "maxTime": -1,
      "minTime": 300
    };
  @Input() loader: Loader;
  @Input() isBGClass: boolean = false;
  constructor(
    private ngxUiLoaderService: NgxUiLoaderService
  ) { }

  ngOnInit(): void {
  }

  fgSlideStart(taskId: string = 'fg-default') {
    this.ngxUiLoaderService.startLoader("master", taskId);
  }

  fgSlideStop(taskId: string = 'fg-default') {
    this.ngxUiLoaderService.stopLoader("master", taskId);
  }

  bgSlideStart(taskId: string = 'bg-default') {
    this.ngxUiLoaderService.startBackgroundLoader("master", taskId);
  }

  bgSlideStop(taskId: string = 'bg-default') {
    this.ngxUiLoaderService.stopBackgroundLoader("master", taskId);
  }


}
